var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSingleOptionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 14C2.625 7.71988 7.71988 2.625 14 2.625C20.2801 2.625 25.375 7.71988 25.375 14C25.375 20.2801 20.2801 25.375 14 25.375C7.71988 25.375 2.625 20.2801 2.625 14ZM14 4.375C8.68637 4.375 4.375 8.68637 4.375 14C4.375 19.3136 8.68637 23.625 14 23.625C19.3136 23.625 23.625 19.3136 23.625 14C23.625 8.68637 19.3136 4.375 14 4.375ZM14 8.75C14.4832 8.75 14.875 9.14175 14.875 9.625V13.125H18.375C18.8582 13.125 19.25 13.5168 19.25 14C19.25 14.4832 18.8582 14.875 18.375 14.875H14.875V18.375C14.875 18.8582 14.4832 19.25 14 19.25C13.5168 19.25 13.125 18.8582 13.125 18.375V14.875H9.625C9.14175 14.875 8.75 14.4832 8.75 14C8.75 13.5168 9.14175 13.125 9.625 13.125H13.125V9.625C13.125 9.14175 13.5168 8.75 14 8.75Z",
    fill: "#8493B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSingleOptionButton);
export default __webpack_public_path__ + "static/media/addSingleOptionButton.50345b5f961f51f1bbee0466017de2fe.svg";
export { ForwardRef as ReactComponent };